module.exports = __webpack_public_path__ + "img/C.b75df93a.png";